export const teams = {
  foley: {
    id: 'foley',
    name: 'Team Foley',
    domain: 'Audio & Sound Design',
    formed: 'Week 7',
    memberIds: [1, 4, 2, 6, 5],
    isUserTeam: true,
    stats: {
      sprintsCompleted: 4,
      avgCraftScore: 95.2,
      totalAnnotations: 8420,
      memberCount: 5,
    },
    craftHistory: [91.0, 92.8, 93.5, 94.2, 95.0, 95.2],
    achievements: [
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 9', date: 'Mar 10, 2026' },
      { label: '10% Rate Boost (6hrs)', sprint: 'Calibration Sprint — Week 11', date: 'Mar 24, 2026' },
    ],
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', status: 'In Progress', craftScore: 94.4, reward: '10% hourly rate boost' },
      { name: 'Calibration Sprint — Week 11', status: 'Cleared', craftScore: 95.5, reward: '10% hourly rate boost' },
      { name: 'Craft Sprint — Week 9', status: 'Cleared', craftScore: 95.0, reward: '$150 cash bonus' },
      { name: 'Knowledge Sprint — Week 7', status: 'Cleared', craftScore: 93.5, reward: 'Priority access (12hrs)' },
    ],
    jobHistory: [
      { title: 'Foley & Environmental Audio', client: 'Confidential — Major Studio', status: 'Active', quality: 96.2, participants: [1, 4, 6], totalAnnotators: 6, date: 'Mar 2026', hours: 142 },
      { title: 'Speech-in-Noise Annotation', client: 'Enterprise Voice AI', status: 'Completed', quality: 95.8, participants: [1, 4, 2, 6, 5], totalAnnotators: 8, date: 'Feb 2026', hours: 280 },
      { title: 'Podcast QA Classification', client: 'StreamVox', status: 'Completed', quality: 94.5, participants: [1, 2, 5], totalAnnotators: 5, date: 'Jan 2026', hours: 96 },
      { title: 'Ambient Soundscape Classification', client: 'AI Research Lab', status: 'Completed', quality: 97.1, participants: [1, 4, 6, 5], totalAnnotators: 4, date: 'Jan 2026', hours: 160 },
      { title: 'Music Genre Boundary Detection', client: 'Harmony ML', status: 'Completed', quality: 93.2, participants: [6, 2], totalAnnotators: 6, date: 'Dec 2025', hours: 88 },
    ],
  },
  waveform: {
    id: 'waveform',
    name: 'Team Waveform',
    domain: 'Audio',
    formed: 'Week 5',
    memberIds: [7, 8, 9, 10, 11],
    isUserTeam: false,
    stats: {
      sprintsCompleted: 5,
      avgCraftScore: 93.8,
      totalAnnotations: 9100,
      memberCount: 5,
    },
    craftHistory: [89.5, 90.8, 91.5, 92.4, 93.0, 93.1],
    achievements: [
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 10', date: 'Mar 17, 2026' },
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 8', date: 'Mar 3, 2026' },
      { label: '10% Rate Boost (6hrs)', sprint: 'Calibration Sprint — Week 6', date: 'Feb 17, 2026' },
    ],
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', status: 'In Progress', craftScore: 93.1, reward: '10% hourly rate boost' },
      { name: 'Craft Sprint — Week 10', status: 'Cleared', craftScore: 93.8, reward: '$150 cash bonus' },
      { name: 'Craft Sprint — Week 8', status: 'Cleared', craftScore: 93.5, reward: '$150 cash bonus' },
      { name: 'Calibration Sprint — Week 6', status: 'Cleared', craftScore: 92.4, reward: '10% hourly rate boost' },
      { name: 'Knowledge Sprint — Week 5', status: 'Cleared', craftScore: 91.5, reward: 'Priority access (12hrs)' },
    ],
    jobHistory: [
      { title: 'Spatial Audio Matching', client: 'SoundAI Corp', status: 'Active', quality: 94.0, participants: [7, 8, 9], totalAnnotators: 5, date: 'Mar 2026', hours: 120 },
      { title: 'Acoustic Event Detection', client: 'Smart Home Co.', status: 'Completed', quality: 95.2, participants: [7, 8, 9, 10, 11], totalAnnotators: 5, date: 'Feb 2026', hours: 250 },
      { title: 'Voice Quality Assessment', client: 'TeleCom AI', status: 'Completed', quality: 93.8, participants: [7, 9, 11], totalAnnotators: 6, date: 'Jan 2026', hours: 104 },
    ],
  },
  syntax: {
    id: 'syntax',
    name: 'Team Syntax',
    domain: 'Linguistics',
    formed: 'Week 3',
    memberIds: [3, 12, 13, 14, 15, 16],
    isUserTeam: false,
    stats: {
      sprintsCompleted: 7,
      avgCraftScore: 96.5,
      totalAnnotations: 12800,
      memberCount: 6,
    },
    craftHistory: [93.0, 94.2, 95.0, 95.8, 96.2, 97.0],
    achievements: [
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 10', date: 'Mar 17, 2026' },
      { label: '10% Rate Boost (6hrs)', sprint: 'Calibration Sprint — Week 11', date: 'Mar 24, 2026' },
      { label: 'Network Spotlight', sprint: 'Knowledge Sprint — Week 7', date: 'Feb 24, 2026' },
    ],
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', status: 'In Progress', craftScore: 97.0, reward: '10% hourly rate boost' },
      { name: 'Calibration Sprint — Week 11', status: 'Cleared', craftScore: 96.8, reward: '10% hourly rate boost' },
      { name: 'Craft Sprint — Week 10', status: 'Cleared', craftScore: 96.2, reward: '$150 cash bonus' },
      { name: 'Knowledge Sprint — Week 7', status: 'Cleared', craftScore: 95.8, reward: 'Priority access (12hrs)' },
    ],
    jobHistory: [
      { title: 'Cross-Lingual Sentiment Analysis', client: 'GlobalComm AI', status: 'Active', quality: 97.0, participants: [3, 12, 13, 14], totalAnnotators: 6, date: 'Mar 2026', hours: 180 },
      { title: 'Multilingual NER Annotation', client: 'LangTech Inc', status: 'Completed', quality: 96.5, participants: [3, 12, 13, 14, 15, 16], totalAnnotators: 6, date: 'Feb 2026', hours: 320 },
      { title: 'Discourse Analysis Tagging', client: 'Academic AI Lab', status: 'Completed', quality: 95.8, participants: [3, 13, 16], totalAnnotators: 4, date: 'Jan 2026', hours: 96 },
    ],
  },
  parallax: {
    id: 'parallax',
    name: 'Team Parallax',
    domain: 'Video',
    formed: 'Week 6',
    memberIds: [2, 17, 18, 19, 20],
    isUserTeam: false,
    stats: {
      sprintsCompleted: 3,
      avgCraftScore: 91.2,
      totalAnnotations: 6200,
      memberCount: 5,
    },
    craftHistory: [87.5, 88.8, 89.5, 90.2, 91.0, 91.8],
    achievements: [
      { label: '10% Rate Boost (6hrs)', sprint: 'Calibration Sprint — Week 11', date: 'Mar 24, 2026' },
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 8', date: 'Mar 3, 2026' },
    ],
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', status: 'In Progress', craftScore: 91.8, reward: '10% hourly rate boost' },
      { name: 'Calibration Sprint — Week 11', status: 'Cleared', craftScore: 92.0, reward: '10% hourly rate boost' },
      { name: 'Craft Sprint — Week 10', status: 'Below Target', craftScore: 89.5, reward: '—' },
      { name: 'Craft Sprint — Week 8', status: 'Cleared', craftScore: 90.2, reward: '$150 cash bonus' },
    ],
    jobHistory: [
      { title: 'VFX Scene Segmentation', client: 'Streaming Platform', status: 'Active', quality: 92.0, participants: [2, 17, 19], totalAnnotators: 5, date: 'Mar 2026', hours: 110 },
      { title: 'Action Recognition Annotation', client: 'AutoDrive Labs', status: 'Completed', quality: 91.5, participants: [2, 17, 18, 19, 20], totalAnnotators: 8, date: 'Feb 2026', hours: 200 },
      { title: 'Object Tracking Dataset', client: 'RoboVision', status: 'Completed', quality: 90.8, participants: [17, 19, 20], totalAnnotators: 5, date: 'Dec 2025', hours: 88 },
    ],
  },
  pixel: {
    id: 'pixel',
    name: 'Team Pixel',
    domain: 'Visual',
    formed: 'Week 4',
    memberIds: [5, 21, 22, 23],
    isUserTeam: false,
    stats: {
      sprintsCompleted: 5,
      avgCraftScore: 94.0,
      totalAnnotations: 7600,
      memberCount: 4,
    },
    craftHistory: [90.0, 91.5, 92.3, 93.0, 93.8, 94.2],
    achievements: [
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 10', date: 'Mar 17, 2026' },
      { label: 'Priority Access (12hrs)', sprint: 'Knowledge Sprint — Week 7', date: 'Feb 24, 2026' },
    ],
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', status: 'In Progress', craftScore: 94.2, reward: '10% hourly rate boost' },
      { name: 'Calibration Sprint — Week 11', status: 'Cleared', craftScore: 93.8, reward: '10% hourly rate boost' },
      { name: 'Craft Sprint — Week 10', status: 'Cleared', craftScore: 93.5, reward: '$150 cash bonus' },
      { name: 'Knowledge Sprint — Week 7', status: 'Cleared', craftScore: 93.0, reward: 'Priority access (12hrs)' },
      { name: 'Craft Sprint — Week 4', status: 'Cleared', craftScore: 91.5, reward: '$150 cash bonus' },
    ],
    jobHistory: [
      { title: 'Image Segmentation QA', client: 'MedVision AI', status: 'Active', quality: 94.5, participants: [5, 21, 22], totalAnnotators: 4, date: 'Mar 2026', hours: 130 },
      { title: 'Depth Estimation Annotation', client: 'AutoNav Systems', status: 'Completed', quality: 94.0, participants: [5, 21, 22, 23], totalAnnotators: 4, date: 'Feb 2026', hours: 240 },
      { title: 'Visual Relationship Detection', client: 'SceneAI', status: 'Completed', quality: 93.2, participants: [5, 21, 23], totalAnnotators: 5, date: 'Jan 2026', hours: 104 },
    ],
  },
  resonance: {
    id: 'resonance',
    name: 'Team Resonance',
    domain: 'Music',
    formed: 'Week 4',
    memberIds: [6, 24, 25, 26, 27],
    isUserTeam: false,
    stats: {
      sprintsCompleted: 6,
      avgCraftScore: 95.1,
      totalAnnotations: 10200,
      memberCount: 5,
    },
    craftHistory: [91.0, 92.5, 93.2, 94.0, 94.8, 95.6],
    achievements: [
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 10', date: 'Mar 17, 2026' },
      { label: '10% Rate Boost (6hrs)', sprint: 'Calibration Sprint — Week 11', date: 'Mar 24, 2026' },
      { label: '$150 Cash Bonus', sprint: 'Craft Sprint — Week 8', date: 'Mar 3, 2026' },
    ],
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', status: 'In Progress', craftScore: 95.6, reward: '10% hourly rate boost' },
      { name: 'Calibration Sprint — Week 11', status: 'Cleared', craftScore: 95.0, reward: '10% hourly rate boost' },
      { name: 'Craft Sprint — Week 10', status: 'Cleared', craftScore: 94.8, reward: '$150 cash bonus' },
      { name: 'Craft Sprint — Week 8', status: 'Cleared', craftScore: 94.0, reward: '$150 cash bonus' },
      { name: 'Knowledge Sprint — Week 5', status: 'Cleared', craftScore: 93.2, reward: 'Priority access (12hrs)' },
      { name: 'Craft Sprint — Week 4', status: 'Cleared', craftScore: 92.5, reward: '$150 cash bonus' },
    ],
    jobHistory: [
      { title: 'Music Structure Annotation', client: 'Harmony ML', status: 'Active', quality: 96.0, participants: [6, 24, 25, 26], totalAnnotators: 5, date: 'Mar 2026', hours: 150 },
      { title: 'Beat Tracking Dataset', client: 'RhythmAI', status: 'Completed', quality: 95.5, participants: [6, 24, 25, 26, 27], totalAnnotators: 5, date: 'Feb 2026', hours: 280 },
      { title: 'Vocal Quality Assessment', client: 'VoiceTech', status: 'Completed', quality: 94.8, participants: [24, 26, 27], totalAnnotators: 4, date: 'Jan 2026', hours: 96 },
      { title: 'Instrument Separation QA', client: 'AudioML Labs', status: 'Completed', quality: 95.0, participants: [6, 25, 26, 27], totalAnnotators: 6, date: 'Dec 2025', hours: 120 },
    ],
  },
};

export const getTeamById = (id) => teams[id];
